import React from 'react';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop, tablet } from 'helpers/utils/screensizes';
import Slider from 'components/commercetools-ui/atoms/slider';

import TimeLineTile from './timelineTile';
import Markdown from 'components/commercetools-ui/organisms/markdown';
export interface TimelineProps {
  data: any;
}
const TimelineComponent: React.FC<TimelineProps> = ({ data }) => {
  const [isTabletSize] = useMediaQuery(desktop);

  return (
    <div className="relative h-full w-full">
      <div className="hidden lg:block">
        <div className="absolute top-1/2 -mt-2 h-4 w-full bg-primary-black"></div>

        <Slider
          slidesPerView={4}
          slidesPerGroup={1}
          dots={false}
          arrows={isTabletSize}
          prevButtonStyles={{
            left: 0,
            zIndex: 10,
          }}
          prevArrowStyles={{ borderWidth: '0 4px  4px 0', borderColor: '#090909' }}
          nextArrowStyles={{ borderWidth: '0 4px  4px 0', borderColor: '#090909' }}
          nextButtonStyles={{
            right: 0,
            zIndex: 10,
          }}
          allowTouchMove
          allowArrowsOnTouchDevice
          containerClassName="h-[15rem] 3xl:h-[20rem]"
          spaceBetween={0}
        >
          {data?.multiple_info?.map((section: any, index: number) => (
            <TimeLineTile section={section} data={data} index={index} key={index} />
          ))}
        </Slider>
      </div>
      <div className="lg:hidden">
        <div className="absolute left-88 top-24 h-[calc(100%-100px)] w-4 bg-primary-black"></div>
        <div className="flex flex-col">
          {data?.multiple_info?.map((section: any, index: number) => (
            <TimeLineTile section={section} data={data} index={index} key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};
export default TimelineComponent;
